// Intermediate node: one per iteration (batch).

import { Handle, Position } from '@xyflow/react';
import { fallbackTheme } from './theme';
import { NODE_SIZES } from './provenanceLayout';

export interface BatchNodeData {
  iteration: number;
  pointCount: number;
  doneCount: number;
  failedCount: number;
}

export default function BatchNode({ data }: { data: BatchNodeData }) {
  const t = fallbackTheme;
  const { width, height } = NODE_SIZES.batch;
  return (
    <div
      style={{
        width,
        height,
        background: t.surface,
        border: `1px solid ${t.border}`,
        borderRadius: 8,
        padding: '8px 10px',
        color: t.text,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <div style={{ fontSize: 10, color: t.textMuted, textTransform: 'uppercase', letterSpacing: 0.5 }}>
        Batch
      </div>
      <div style={{ fontSize: 14, fontWeight: 600 }}>Iter {data.iteration}</div>
      <div style={{ fontSize: 10, color: t.textMuted }}>
        {data.pointCount} pts · {data.doneCount} done
        {data.failedCount > 0 && (
          <span style={{ color: t.status.failed }}> · {data.failedCount} failed</span>
        )}
      </div>
      <Handle type="target" position={Position.Top} style={{ background: t.border }} />
      <Handle type="source" position={Position.Bottom} style={{ background: t.border }} />
    </div>
  );
}
